
import { Component, Inject, Prop, Vue } from 'nuxt-property-decorator'
import { Validator } from 'vee-validate/types/vee-validate.d'
import { SupportedProviders, ProviderModel } from '@alao-frontend/erp-services'
import AddressFilter from '~/components/filters/AddressFilter/AddressFilter.vue'
import ProvidersFilter from '~/components/filters/ProvidersFilter.vue'
import ProvidersListStatic from '~/components/snippets/ProvidersListStatic.vue'
import { OfferType, OfferTypeByShortName, Provider } from '~/core/offer.types'
import { $api } from '~/plugins/axios'

import { addressObservable } from '~/observables/modules/address'
import { AlButton } from '~/components/ui'

@Component({
  components: {
    AlButton,
    AddressFilter,
    ProvidersFilter,
    ProvidersListStatic,
  },
})
export default class AddressModalContent extends Vue {
  @Inject('$validator')
  $validator!: Validator

  @Prop({ required: true, default: 1, type: Number })
  readonly offerId!: number

  @Prop({ required: false, default: () => [], type: Array })
  readonly providers?: ProviderModel[]

  @Prop({ required: true, default: OfferTypeByShortName.home, type: String })
  readonly offerType!: OfferTypeByShortName

  @Prop({ required: true, type: String })
  readonly providerSlug!: SupportedProviders

  get type () {
    return OfferType[this.offerType]
  }

  async onSubmit () {
    const isValid = await this.$validator.validate()
    if (!isValid) {
      return
    }
    try {
      const payload = {
        zip: addressObservable.zip,
        city: addressObservable.city,
        street: addressObservable.street,
        house: addressObservable.number,
        provider: this.providerSlug,
      }

      const { has_internet } = await $api.PublicAddressService.addressCheckByProviderRuntime(this.providerSlug, payload)
      this.$emit('on-submit', has_internet)
    } catch (e) {
      // TODO: Handle error
      this.$emit('on-submit', false)
    }
  }
}
